<template>
  <span>
    <BotPageTitle />
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px;"
    >
      {{ $t("drawer.users.subitems.usersList") }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item ml-auto">
        <md-button @click="toUserPage" style="float: right;" class="md-warning">
          <img
            :src="icons.createUser"
            style="height: 26px; width: 26px; margin-right: 10px;"
          />
          <span style="color: black">{{ $t("usersList.newUser") }}</span>
        </md-button>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>list_alt</md-icon>
            </div>
            <h4 class="title">{{ $t("drawer.users.subitems.usersList") }}</h4>
          </md-card-header>
          <md-card-content>
            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="pages">{{ $t("usersList.perPage") }}</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      {{ item }}
                    </md-option>
                  </md-select>
                </md-field>

                <md-field>
                  <md-input
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px"
                    :placeholder="$t('usersList.search') + '...'"
                    v-model="searchQuery"
                  >
                  </md-input>
                </md-field>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  :md-label="$t('usersList.userName')"
                  md-sort-by="name"
                  >{{ item.name }}</md-table-cell
                >
                <md-table-cell :md-label="$t('usersList.email')">{{
                  item.email
                }}</md-table-cell>
                <md-table-cell :md-label="$t('usersList.profile')">{{
                  item.profile
                }}</md-table-cell>
                <md-table-cell :md-label="$t('usersList.status')">
                  <md-checkbox v-model="item.status"></md-checkbox>
                  <img
                    :src="icons.pencil"
                    style="height: 26px; width: 26px; cursor: pointer; margin: 12.5px 25px 12.5px 0;"
                  />
                  <!-- <img
                    :src="icons.gear"
                    style="height: 26px; width: 26px; cursor: pointer;"
                  /> -->
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div class="footer-table md-table">
              <table>
                <tfoot>
                  <tr>
                    <th
                      v-for="item in footerTable"
                      :key="item.name"
                      class="md-table-head"
                    >
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          {{ item }}
                        </div>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">
                {{
                  $t("usersList.showingItems", {
                    from: from + 1,
                    to: to,
                    total: total
                  })
                }}
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </span>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import usersList from './data/usersList'
import Fuse from 'fuse.js'
import Swal from 'sweetalert2'
import BotPageTitle from '@/components/BotPageTitle.vue'

export default {
  components: {
    Pagination,
    BotPageTitle
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData () {
      let result = this.tableData
      if (this.searchedData.length > 0) {
        result = this.searchedData
      }
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length
    }
  },
  data () {
    return {
      currentSort: 'name',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      footerTable: [
        this.$t('usersList.userName'),
        this.$t('usersList.email'),
        this.$t('usersList.profile'),
        this.$t('usersList.status')
      ],
      searchQuery: '',
      propsToSearch: ['name', 'email', 'profile'],
      tableData: usersList,
      searchedData: [],
      fuseSearch: null,
      icons: {
        createUser: require('../../public/img/create-user-icon.png'),
        pencil: require('../../public/img/pencil-icon.png')
      }
    }
  },
  methods: {
    customSort (value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === 'desc') {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    handleLike (item) {
      Swal.fire({
        title: `${this.$t('usersList.youLiked')} ${item.name}`,
        buttonsStyling: false,
        type: 'success',
        confirmButtonClass: 'md-button md-success'
      })
    },
    handleEdit (item) {
      Swal.fire({
        title: `${this.$t('usersList.youWantToEdit')} ${item.name}`,
        buttonsStyling: false,
        confirmButtonClass: 'md-button md-info'
      })
    },
    handleDelete (item) {
      Swal.fire({
        title: this.$t('usersList.areYouSure'),
        text: this.$t('usersList.youWontBeAbleToRevertThis'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('usersList.yesDeleteIt'),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(item)
          Swal.fire({
            title: this.$t('usersList.deleted'),
            text: `${this.$t('usersList.youDeleted')} ${item.name}`,
            type: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false
          })
        }
      })
    },
    deleteRow (item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      )
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1)
      }
    },
    goTo (path) {
      this.$router.push(path)
    },
    toUserPage () {
      this.$router.push('/user-edit')
    }
  },
  mounted () {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ['name', 'channel'],
      threshold: 0.3
    })
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery (value) {
      let result = this.tableData
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    }
  }
}
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
</style>
